import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';

import { BrowserRouter } from 'react-router-dom';
import 'core-js/stable';
import 'oui';
import StackingSnackbarProvider from './ui/component/StackingSnackbar/StackingSnackbarProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
    // @ts-ignore
  // <React.StrictMode>
  <RecoilRoot>
    <BrowserRouter>
      <StackingSnackbarProvider>
        <App />
      </StackingSnackbarProvider>
    </BrowserRouter>
  </RecoilRoot>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
